"use client";

import { usePathname } from "next/navigation";
import Image from "next/image"

import NavMenu from "../NavMenu";
import moment from 'moment';
import Countdown from 'react-countdown-now';
import { SpeelMee } from "./speel-mee"

import { useCompetitionContext } from "../providers/CompetitionContext";

export const HomeBanner = () => {
  const pathname = usePathname();
  const { brand, competitionData } = useCompetitionContext();

  const deadlineRenderer = ({ days, hours, minutes }: any) => {
    return (
      <span className='deadline'>
        {/* <ClockCircleOutlined /> {days}d {hours}u {minutes}min */}
        {days}d {hours}u {minutes}min
      </span>
    );
  };

  const deadline = moment.utc(competitionData?.deadlineInfo?.deadlineDate).valueOf()
  
  // Only render for the root route
  if (pathname !== "/") return <>
    <div className="container max-w-[1140px] text-xs mx-auto my-0 py-2 min-h-full text-white">
      Stel jouw Klassieker-team samen!
    </div>
    <NavMenu />
  </>;

  return (
    <header className="overflow-hidden bg-[#F5F5F5]">
      <div className="relative">
        <Image
          src="https://dpgnl.s3.eu-west-1.amazonaws.com/files/klas-header.jpg"
          alt="Klassiekerspel background"
          fill
          className="object-cover object-right"
          priority
        />
        <div className="relative">
          <div className="container max-w-[1140px] text-xs mx-auto my-0 p-2 min-h-full text-white">
            Stel jouw Klassieker-team samen!
          </div>
          <NavMenu />
          <div className="container max-w-[1140px] mx-auto min-h-full text-white">
            <div className="m-4 md:ml-[30%] md:w-2/3"> {/* Added container for right-aligned content on desktop */}
              <div className="inline-block my-4 bg-white px-1 text-xs">
                <div className="inline-block bg-[#cc0000] text-white p-1.5">
                  <Countdown
                    renderer={deadlineRenderer}
                    date={deadline}
                  />
                </div>
                <div className="inline-block text-black p-2.5">
                  tot de volgende koers begint!
                </div>
              </div>
              <h1 className="my-4 text-xl md:text-4xl font-bold text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
                Stel gratis jouw Klassieker-team samen en win fantastische prijzen!
              </h1>
              <p className="my-4 text-md md:text-md text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
                Stel je droomteam samen, scoor punten en maak kans op prijzen per koers en in het algemeen klassement. Doe vandaag nog mee!
              </p>
              <SpeelMee />
              <p className="pb-8 my-4 text-xs">Stel jouw €100 miljoen budget wielerteam samen voor de klassiekers!</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}